import { Link } from "react-router-dom";
import { localizePath } from "@plaatplan/i18n";
import { useLocale } from "./useLocale.js";

/**
 * @param {{ to: string, children: import("react").ReactNode } & import("react-router-dom").LinkProps} props
 */
export function LocalizedLink({ to, ...props }) {
  const { preferences } = useLocale();
  const resolvedTo = typeof to === "string" && to.startsWith("/")
    ? localizePath(to, preferences.locale)
    : to;

  return <Link to={resolvedTo} {...props} />;
}

/**
 * @returns {(path: string) => string}
 */
export function useLocalizedPath() {
  const { preferences } = useLocale();

  return (path) => localizePath(path, preferences.locale);
}
